<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">{{ group_detail.name }} ({{ group_detail.clients.length }}) ID: {{ $route.params.id }}</h1>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <button class="info-cards__control" @click="onShowEditGroupModal">
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Tour start:</span><span>{{ dateFormat(group_detail.tour_start) }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Tour finish:</span><span>{{ dateFormat(group_detail.tour_end) }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view :groupDetail="group_detail" @getGroupInfo="getGroupInfo" />
      </transition>
    </template>
    <modal
      name="island-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('island-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit island vacation</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckIslandForm">
            <app-form-group label="Group name" label-for="group_name_free" required>
              <app-input
                v-model="island_form.name"
                :error="$v.island_form.name.$error"
                id="group_name_free"
                placeholder="Group name"
                name="group_name_free"
              />
              <template #error>
                <div v-if="$v.island_form.name.$dirty && !$v.island_form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Tour start" required>
              <app-date-picker
                v-model="island_form.tour_start"
                placeholder="Tour start"
                :error="$v.island_form.tour_start.$error"
              />
              <template #error>
                <div v-if="$v.island_form.tour_start.$dirty && !$v.island_form.tour_start.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Tour finish" required>
              <app-date-picker
                v-model="island_form.tour_end"
                placeholder="Tour finish"
                :error="$v.island_form.tour_end.$error"
              />
              <template #error>
                <div v-if="$v.island_form.tour_end.$dirty && !$v.island_form.tour_end.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="island_submit" :disabled="$v.island_form.$error">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getIslandVacationGroup, patchIslandVacationGroup } from '@/http'
import { format, parse } from 'date-fns'
import AppTabs from '@/components/AppTabs'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'IslandVacationGroupsDetailLayout',
  components: { AppTabs },
  data() {
    return {
      is_loaded: false,
      tabs: [
        { name: 'island-vacation-groups-detail-clients', label: 'Clients' },
        { name: 'island-vacation-groups-detail-itinerary', label: 'Itinerary' },
      ],
      group_detail: {},
      island_form: {},
    }
  },
  validations: {
    island_form: {
      name: { required },
      tour_start: { required },
      tour_end: { required },
    },
  },
  created() {
    getIslandVacationGroup(this.$route.params.id)
      .then(response => {
        this.group_detail = response.data
        document.title = `${this.group_detail.name} (${this.group_detail.clients.length}) ID: ${ this.$route.params.id } | Altezza Board`
        this.is_loaded = true
      })
  },
  methods: {
    onShowEditGroupModal() {
      this.island_form = {
        tour_start: this.group_detail.tour_start,
        tour_end: this.group_detail.tour_end,
        name: this.group_detail.name,
      }
      this.$modal.show('island-modal')
    },
    onCheckIslandForm() {
      this.$v.island_form.$touch()
      if (this.$v.island_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendIslandForm()
      }
    },
    sendIslandForm() {
      this.$refs.island_submit.preload = true
      patchIslandVacationGroup(this.$route.params.id, this.island_form)
        .then(() => {
          this.getGroupInfo()
          this.$notify({
            type: 'success',
            title: 'Group edited',
          })
          this.$modal.hide('island-modal')
        })
        .catch(() => {
          this.$refs.island_submit.preload = false
        })
    },
    getGroupInfo() {
      getIslandVacationGroup(this.$route.params.id)
        .then(response => {
          this.group_detail = response.data
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
  }
}
</script>
